import { FC, useMemo } from 'react';
import { Divider } from 'antd';
import styled from 'styled-components';
import { ProcSubmitButton } from '@/entities/proc';
import { UserProcResponse } from '@/shared/api';
import { useRouterContext } from '@/shared/router';
import { themeConfig, useThemeContext } from '@/shared/theme';
import { Row } from '@/shared/ui';
import { PageLayoutHeaderGoBackBtn } from '@/widgets/page-layout';

type Props = {
  procInstance?: UserProcResponse;
};

export const MyProcInstancePageHeader: FC<Props> = ({ procInstance }) => {
  const { theme } = useThemeContext();
  const { dashboardGoBackLink } = useRouterContext();

  const shouldShowSubmitButton = useMemo(
    () =>
      procInstance?.stepData.administration.showSubmitButton &&
      (procInstance?.state === 'active' ||
        procInstance?.state === 'instantiated'),
    [procInstance],
  );

  return (
    <HeaderWrapper justifyContent="space-between">
      <PageLayoutHeaderGoBackBtn
        path={dashboardGoBackLink}
        label="Go back to dashboard"
      />
      {shouldShowSubmitButton && (
        <Row style={{ width: 'auto' }}>
          <ProcSubmitButton />
          <Divider
            type="vertical"
            style={{
              fontSize: 35,
              borderInlineStart: `1px solid ${themeConfig[theme].colors.border}]}`,
              top: 0,
              marginLeft: 15,
            }}
          />
        </Row>
      )}
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled(Row)`
  width: 100%;
`;
